<div class="flex flex-col">
    <!-- 'top-9': hasBanner(), 'top-0': !hasBanner() -->
    <header
        class="flex sticky left-0 right-0 top-0 items-center gap-6 py-1 z-40 transition-colors backdrop-blur-md duration-500 justify-between overflow-x-clip"
        [ngClass]="{'bg-[#fafafa]': !scrolled(), 'bg-opacity-60 bg-white text-[#3F4444] shadow-sm': scrolled(),}">
        <nav class="flex w-full items-center justify-between gap-4 px-4 py-2">
            <div class="flex items-center gap-2 shrink-0">
                <button matIconButton (click)="toggleMenu()" [attr.aria-expanded]="isMenuVisible()"
                    [attr.aria-label]="isMenuVisible() ? 'Recolher menu lateral' : 'Abrir menu lateral'">
                    <mat-icon>{{ isMenuVisible() ? 'menu_open' : 'menu' }}</mat-icon>
                </button>

                <a routerLink="/home" aria-label="Ir para a home" class="hidden sm:block">
                    <img src="assets/logo-otimiza.svg" alt="Otimiza" class="h-5">
                </a>
            </div>

            <!-- A navegação saiu da navbar; a busca é o atalho para as ferramentas. -->
            <mat-form-field class="w-full max-w-md" appearance="outline" subscriptSizing="dynamic">
                <mat-icon matPrefix>search</mat-icon>
                <input matInput type="text" placeholder="O que você procura?" [matAutocomplete]="auto"
                    [ngModel]="busca()" (ngModelChange)="busca.set($event)">
            </mat-form-field>

            <mat-autocomplete #auto class="tool-search-panel" [displayWith]="semTexto"
                (optionSelected)="abrir($event.option.value)">
                <!-- Recentes só aparecem com o campo vazio; digitando, manda o termo. -->
                @if (recentes().length) {
                <mat-optgroup label="Buscas recentes">
                    @for (ferramenta of recentes(); track chaveTool(ferramenta)) {
                    <mat-option [value]="ferramenta">
                        <mat-icon class="align-middle text-gray-400">history</mat-icon>
                        <span>{{ ferramenta.title }}</span>
                        @if (ferramenta.section) {
                        <span class="ms-2 text-xs text-gray-400">{{ ferramenta.section }}</span>
                        }
                    </mat-option>
                    }
                </mat-optgroup>
                }

                @for (ferramenta of resultados(); track chaveTool(ferramenta)) {
                <mat-option [value]="ferramenta">
                    <span>{{ ferramenta.title }}</span>
                    @if (ferramenta.section) {
                    <span class="ms-2 text-xs text-gray-400">{{ ferramenta.section }}</span>
                    }
                </mat-option>
                } @empty {
                <mat-option disabled>Nenhuma ferramenta encontrada</mat-option>
                }
            </mat-autocomplete>

            <div class="hidden shrink-0 md:block">
                <app-user></app-user>
            </div>
        </nav>
    </header>

    <!-- No desktop o menu nunca sai da tela: recuado, ele vira uma trilha só de ícones.
         Por isso este bloco fica fora do @if e só troca de largura — quem esconde o
         texto é o `.rail`, lido via :host-context nos componentes do menu. -->
    <div [ngClass]="isMenuVisible() ? 'max-w-72' : 'rail max-w-[64px]'"
        class="menu-passo hidden md:flex scrollbar scrollbar-thumb-transparent top-16 scrollbar-track-transparent overflow-y-auto fixed bottom-0  flex-col z-40 w-full text-sm shadow-lg bg-[#ffffffef] backdrop-blur-md m-2 rounded-xl transition-all duration-300">
        <nav class="flex flex-col flex-grow w-full h-full mx-auto">
            <app-menu-header class="w-full h-full flex flex-col"></app-menu-header>
        </nav>
    </div>

    @if (isMenuVisible()) {
    <!-- [ngClass]="{'top-4': hasBanner()}" -->
    <div @fadeSlideInOut
        class="flex md:hidden scrollbar scrollbar-thumb-transparent scrollbar-track-transparent overflow-y-auto fixed inset-0 flex-col z-40 border-r border-gray-200 text-sm shadow-lg bg-[#ffffffef] backdrop-blur-md rounded-xl transition-all duration-300">
        <nav class="flex flex-col flex-grow w-full h-full mx-auto">
            <app-menu-header (toggleMenu)="toggleMenu()" class="w-full h-full flex flex-col"></app-menu-header>
        </nav>
    </div>
    }

    <!-- Largura do menu + os 8px de margem de cada lado: 288+16 aberto, 64+16 recuado.
         O breakpoint acompanha o do próprio menu (md), senão entre 640px e 768px o
         conteúdo recuava sem menu nenhum à vista. -->
    <div [ngClass]="isMenuVisible() ? 'md:ps-[304px]' : 'md:ps-[80px]'"
        class="min-w-0 transition-all duration-300 ease-in-out bg-[#fafafa] min-h-[calc(100dvh-72px)]">
        <ng-content></ng-content>
    </div>
</div>
